import { BLOCKCHAIN_INFO_MAP, ethlikeBlockchains, mainnetList, networkConfigs, } from '../blockchains/blockchainConfigs';
export const isMainnet = (network) => {
    return mainnetList.includes(network);
};
export const isSupportedNetwork = (network, platforms) => {
    const supportedNetworks = networkConfigs.reduce((acc, cur) => {
        if (platforms.some((platform) => cur.isSupported.includes(platform))) {
            acc.push(cur.network);
        }
        return acc;
    }, []);
    return supportedNetworks.includes(network);
};
export const networkToBlockchain = (network) => {
    if (!network)
        throw new Error(`networkToBlockchain() network: ${network}`);
    const networkLowerCase = network === null || network === void 0 ? void 0 : network.toLowerCase();
    const config = networkConfigs.find((config) => config.network === networkLowerCase);
    if (!config)
        throw new Error(`Unsupported network: ${networkLowerCase}`);
    return config.blockchain;
};
export const getPlatFormCoinDecimalByBlockchain = (blockchain) => {
    if (Object.prototype.hasOwnProperty.call(BLOCKCHAIN_INFO_MAP, blockchain)) {
        return BLOCKCHAIN_INFO_MAP[blockchain].decimal;
    }
    throw new Error('unsupported blockchain');
};
export const isEthlikeNetwork = (network) => {
    return ethlikeBlockchains.includes(networkToBlockchain(network));
};
export const isEthlikeBlockchain = (blockchain) => {
    return ethlikeBlockchains.includes(blockchain);
};
export const getTestnetNetworkFromBlockchain = (blockchain) => {
    var _a;
    const network = (_a = networkConfigs.find((config) => !config.isMainnet && config.blockchain === blockchain)) === null || _a === void 0 ? void 0 : _a.network;
    if (!network)
        throw new Error('Unsupported blockchain ' + blockchain);
    return network;
};
export const getMainnetNetworkFromBlockchain = (blockchain) => {
    var _a;
    const network = (_a = networkConfigs.find((config) => config.isMainnet && config.blockchain === blockchain)) === null || _a === void 0 ? void 0 : _a.network;
    if (!network)
        throw new Error('Unsupported blockchain ' + blockchain);
    return network;
};
export const getChainId = (network) => {
    var _a;
    const id = (_a = networkConfigs.find((config) => config.network === network)) === null || _a === void 0 ? void 0 : _a.chainId;
    if (!id)
        throw new Error('Unsupported network ' + network);
    return id;
};
export const getNetworkByChainId = (chainId) => {
    var _a;
    const network = (_a = networkConfigs.find((config) => config.chainId === chainId)) === null || _a === void 0 ? void 0 : _a.network;
    if (!network)
        throw new Error('Unsupported network ' + network);
    return network;
};
//# sourceMappingURL=blockchain.js.map